import RequestService, {METHODS} from '@/services/RequestService';
import {IResetPassword, IRetrievePassword, ISignIn, ISignUp} from './interfaces';

class AuthApi extends RequestService {
    async signIn({data}: ISignIn) {
        return await this.request({url: `/auth/sign-in`, method: METHODS.post, data});
    }

    async signUp({data}: ISignUp) {
        return await this.request({url: `/auth/register`, method: METHODS.post, data});
    }

    async retrievePassword({data}: IRetrievePassword) {
        return await this.request({url: `/auth/retrieve-password`, method: METHODS.post, data});
    }

    async resetPassword({data}: IResetPassword) {
        return await this.request({url: `/auth/reset-password`, method: METHODS.post, data});
    }
}

export default new AuthApi();
